module.exports = __webpack_public_path__ + "img/two.f91275f3.svg";